export default function WaitingAgent({ waitingAgentCheck }: { waitingAgentCheck: boolean }) {


    if (waitingAgentCheck) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Venter på at agenten skal motta samtalen"}
                </h3>
                <div className="animate-pulse text-purple-600 font-medium">
                    {"Venter på å bli akseptert..."}
                </div>
            </section>
        )
    }
}